import React from 'react';
import { Tag, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';

import { AiClipperUserBreakdownRow } from 'api/aiClipperMetrics/types';

import styles from './AIClipperMetrics.module.scss';
import { formatRatePct } from './helpers';

const { Text } = Typography;

export const userColumns: ColumnsType<AiClipperUserBreakdownRow> = [
  {
    title: 'Athlete',
    key: 'name',
    render: (_: unknown, row) => (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Text strong>
          {row.userName || <Text type="secondary">Unknown</Text>}
        </Text>
        {row.userSlug ? (
          <Text type="secondary" style={{ fontSize: 12 }}>
            {row.userSlug}
          </Text>
        ) : null}
      </div>
    ),
  },
  {
    title: 'Generated',
    dataIndex: 'candidatesGenerated',
    key: 'candidatesGenerated',
    width: 120,
    align: 'right',
    render: (value: number) => (
      <Text className={styles.numericCell}>{value}</Text>
    ),
  },
  {
    title: 'Accepted',
    dataIndex: 'accepted',
    key: 'accepted',
    width: 110,
    align: 'right',
    render: (value: number) => (
      <Tag color="green" className={styles.numericCell}>
        {value}
      </Tag>
    ),
  },
  {
    title: 'Manual',
    dataIndex: 'manualAccepted',
    key: 'manualAccepted',
    width: 110,
    align: 'right',
    render: (value: number) => (
      <Tag color="green" className={styles.numericCell}>
        {value}
      </Tag>
    ),
  },
  {
    title: 'System',
    dataIndex: 'systemAccepted',
    key: 'systemAccepted',
    width: 110,
    align: 'right',
    render: (value: number) => (
      <Tag color="blue" className={styles.numericCell}>
        {value}
      </Tag>
    ),
  },
  {
    title: 'Rejected',
    dataIndex: 'rejected',
    key: 'rejected',
    width: 110,
    align: 'right',
    render: (value: number) => (
      <Tag color="red" className={styles.numericCell}>
        {value}
      </Tag>
    ),
  },
  {
    title: 'Pending',
    dataIndex: 'pendingReview',
    key: 'pendingReview',
    width: 110,
    align: 'right',
    render: (value: number) => (
      <Tag color="gold" className={styles.numericCell}>
        {value}
      </Tag>
    ),
  },
  {
    title: 'Approval rate',
    key: 'rate',
    width: 140,
    align: 'right',
    render: (_: unknown, row: AiClipperUserBreakdownRow): JSX.Element => {
      const reviewed = row.accepted + row.rejected;
      const pct = reviewed === 0 ? null : (row.accepted / reviewed) * 100;
      return (
        <Text strong className={styles.numericCell}>
          {formatRatePct(pct)}
        </Text>
      );
    },
  },
];
